import React from 'react';
import { Link } from 'react-router-dom';
import { Grid, Typography } from '@mui/material';
import { abbreviateNumber } from 'utils/utils';
import Loader from 'components/loader/Loader';
import CommonNoDataFound from 'components/CommonNoDataFound/CommonNoDataFound';
import companyBlue from 'assets/images/CompnayTop.svg';

function TopCompanies(props) {

  return (
    <div className='topCompanies'>
      <Grid container className="justifyBetween">
        <Grid item>
          <Typography variant="head5" className="fw600">
            Leading Companies
          </Typography>
        </Grid>
        <Grid item>
        <Link to="/companies" className='font16 colorPrimary'>View All Companies</Link>;
        </Grid>
      </Grid>

     {props?.loader ? <Loader height={'10vh'}/> :
     <>{props?.data?.length >0 ?
      <Grid container className="borderShadowGrey mb25 p25">
        {props?.data?.map((ele, idx) => (
        <Grid key={idx} item md={2.7} sm={12} className='borderShadowGrey p20 m10'>
          <Grid className="alignItem">
            <img src={companyBlue} alt="company" className="mr10 wh38" />
          </Grid>
          <Grid>
          <Typography variant="body2" className="fw600 colorPrimary">
              {ele?.compName}
            </Typography>
          </Grid>
          <Grid>
            <Typography variant="body2" className="fw400">
              {ele?.count} <span className="font14 colorGrey fw400">trips</span>
            </Typography>
          </Grid>
          <Grid container flexDirection='column'>
            <Grid item>
            <Typography variant="body2" className="fw400">
              {'₹ ' +abbreviateNumber(ele?.amount||0)}
            </Typography>
            </Grid>
            <Grid item>
            <Typography className="font14 colorGrey fw400"> &nbsp;transactions so far...</Typography>
            </Grid>
          </Grid>
        </Grid>))}
      </Grid> : <CommonNoDataFound/>}
      </>}
    </div>
  );
}

export default TopCompanies;

